import { PATH_APP } from 'routes/paths';
import { getChartHubSections } from './chartHubCatalog';

/** Normalize for sidebar active matching (ignore query/hash/trailing slash). */
export function normalizeChartNavPath(path) {
  if (!path) return '';
  const base = String(path).split('?')[0].split('#')[0];
  return base.length > 1 && base.endsWith('/') ? base.slice(0, -1) : base;
}

export function isChartNavPathActive(pathname, chartPath) {
  return normalizeChartNavPath(pathname) === normalizeChartNavPath(chartPath);
}

/** Sidebar group chrome — icons / default expand; must match section `id` in chartHubCatalog. */
const SECTION_NAV_META = {
  revenue: { icon: 'mdi:currency-usd', defaultOpen: true },
  subscriptions: { icon: 'mdi:account-multiple', defaultOpen: false },
  'cohorts-ltv': { icon: 'mdi:chart-timeline-variant', defaultOpen: false },
  conversion: { icon: 'mdi:funnel', defaultOpen: false },
  trials: { icon: 'mdi:clock-outline', defaultOpen: false },
  churn: { icon: 'mdi:arrow-down-circle', defaultOpen: false },
  marketing: { icon: 'mdi:bullhorn', defaultOpen: false },
};

/**
 * Build collapsible sidebar chart groups from the hub catalog (labels + paths stay in sync).
 */
export function buildChartNavGroups(appId, organizationRole) {
  const sections = getChartHubSections(organizationRole);

  return sections
    .map((section) => {
      const meta = SECTION_NAV_META[section.id] || { icon: 'mdi:chart-line', defaultOpen: false };
      const charts = section.items
        .map((item) => {
          const resolvePath = PATH_APP.application.chart[item.pathKey];
          if (!resolvePath) {
            return null;
          }
          return {
            pathKey: item.pathKey,
            title: item.label,
            subtitle: item.subtitle,
            path: resolvePath(appId),
            icon: item.icon,
            cohortView: Boolean(item.cohortView),
          };
        })
        .filter(Boolean);

      return {
        id: section.id,
        title: section.title,
        icon: meta.icon,
        defaultOpen: meta.defaultOpen,
        charts,
      };
    })
    .filter((group) => group.charts.length > 0);
}
